import { Merchant } from "client/lib/apt-merchant";

import type { AmplitudeMerchantProps } from "./amplitude-types";

export const getMerchantPropertiesForAmplitude = (
  merchant: Merchant
): AmplitudeMerchantProps => {
  const merchantProps = {
    // Merchant Account
    mlsProspectRef: merchant.merchantAccount.mlsProspectRef,
    merchantId: merchant.merchantAccount.merchantId,
    opportunityOwnerEmail: merchant.merchantAccount.opportunityOwnerEmail,
    // leadFieldset
    franchisee: merchant.lead.franchisee.value,
    // companyInfoFieldset
    aveTimeToShip: merchant.storeDetails.aveTimeToShip.value,
    contactlessPayment: merchant.storeDetails.contactlessPayment.value,
    industry: merchant.storeDetails.industry.value,
    platform: merchant.storeDetails.platform.value,
    preOrders: merchant.storeDetails.preOrders.value,
    registeredCountry: merchant.companyInformation.registeredCountry.value,
    salesChannel: merchant.storeDetails.salesChannel.value,
    totalAnnualSales: merchant.storeDetails.totalAnnualSales.value,
    websiteNotLive: merchant.storeDetails.websiteNotLive.value,
    // store locations
    locations: merchant.locations.map(
      ({ locationCity, locationState, label }) => ({
        locationCity: locationCity.value,
        locationState: locationState.value,
        label: label.value,
      })
    ),
  };

  // remove keys with empty values
  Object.keys(merchantProps).forEach((merchantKey) => {
    const key = merchantKey as keyof AmplitudeMerchantProps;
    const val = merchantProps[key];
    if (
      typeof val === "undefined" ||
      val === "" ||
      (Array.isArray(val) && val.length === 0)
    ) {
      delete merchantProps[key];
    }
  });

  return merchantProps;
};
